// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"bbd4a274","prefillPills":"b1221363","prefillPill":"c8008d85","inputContainer":"e6f74ac7","messageInput":"e53346f2","antInput":"ce63de5f","sendButton":"cb46adc6"};